import { type DraftPayment, DraftPaymentStatus } from "@/apis/gql/types";

export function getPaymentAmountToPay(
  draftPayments: Pick<DraftPayment, "status" | "amount">[],
) {
  if (!draftPayments) return 0;

  return draftPayments
    .filter((payment) => payment.status === DraftPaymentStatus.DRAFT)
    .reduce((acc: number, payment) => acc + (payment.amount ?? 0), 0);
}
